export const ROLE_LABEL = {
  company_admin: 'Company Admin',
  field_rep:     'Field Rep',
  stakeholder:   'Stakeholder',
} as const;

/**
 * Role <select> options derived from ROLE_LABEL so the dropdowns
 * and the read-only tags can't drift apart.
 */
export const ROLE_OPTIONS = (
  Object.keys(ROLE_LABEL) as Array<keyof typeof ROLE_LABEL>
).map((value) => ({ label: ROLE_LABEL[value], value }));

export const STATUS_LABEL  = { new: 'New', active: 'Active', closed: 'Closed', archived: 'Archived' } as const;
export const TEMP_LABEL    = { hot: '🔥 Hot', warm: 'Warm', cold: 'Cold' } as const;
export const CAPTURE_LABEL = { voice: 'Voice note', card: 'Card scan', badge: 'Badge scan' } as const;
export const STAGE_LABEL   = { discovery: 'Discovery', qualifying: 'Qualifying', proposal: 'Proposal', closed_won: 'Closed Won', closed_lost: 'Closed Lost' } as const;

type Domain = 'role' | 'status' | 'temp' | 'capture' | 'stage';
const DICT: Record<Domain, Record<string, string>> = {
  role: ROLE_LABEL, status: STATUS_LABEL, temp: TEMP_LABEL, capture: CAPTURE_LABEL, stage: STAGE_LABEL,
};

export function displayName(domain: Domain, code: string | null | undefined): string {
  if (!code) return '';
  return DICT[domain]?.[code] ?? code;
}
